module.exports = __webpack_public_path__ + "img/1.e1d2eb48.jpg";